import script from "./MainNav.vue?vue&type=script&setup=true&lang=js"
export * from "./MainNav.vue?vue&type=script&setup=true&lang=js"

import "./MainNav.vue?vue&type=style&index=0&id=d2f55a24&lang=css"

const __exports__ = script;

export default __exports__